import {Injectable} from "@angular/core";
import {StaticsService} from "../sys/statics.service";
import {QueryManagerService} from "./query-manager.service";
import {QueryCategory} from "../model/queryCategory";

declare var $: any;

@Injectable()
export class QueryStringBuilderService {

    public static readonly QUERY_URL_START: string  = "";
    public static readonly QUERY_DCGIND_TRUE  = "1";

    constructor(private staticsService: StaticsService,
                private queryManagerService: QueryManagerService) {

    }

    ngOnInit() {

    }

    public getQueryString(): string {
        let queryStr: string = "";

        const queryCategories: QueryCategory[] = this.queryManagerService.getQueryCategories();

        if (queryCategories.length != 0) {
            queryStr = QueryStringBuilderService.QUERY_URL_START;
            queryStr = queryStr + this.buildSearchString(queryCategories);
        }
        return queryStr;
    }
    private isEinPnCombo(queryCategories: QueryCategory[]) : boolean {
      
        let isEinFound: boolean = false;
        let isPnFound: boolean = false;

        for (let queryCategory  of queryCategories) {
            if (queryCategory.type == this.staticsService.getCategoryType().EIN) {
                isEinFound = true;
            }
            if (queryCategory.type == this.staticsService.getCategoryType().PN) {
                isPnFound = true;
            }
        }

        return isEinFound && isPnFound;
    } 

    private isIgnoredCategories(categoryType: string) :boolean {

        let isIgnored = false;

        if (categoryType == this.staticsService.getCategoryType().EIN ||
            categoryType == this.staticsService.getCategoryType().PN) {
            isIgnored = true;
        }
   
        return isIgnored;   
    }

    private buildSearchString(queryCategories: QueryCategory[]) : string {

        let qStr: string = "(";
        let categoryCnt: number = 0;
        let isCategoryEinPnCombo = false;

        isCategoryEinPnCombo =  this.isEinPnCombo(queryCategories);

        for (let queryCategory  of queryCategories) {
            
            let isNeedingOr: boolean = false;

            if (queryCategory.isFilter) {
                isNeedingOr = true;
            }
            else {
                isNeedingOr = this.isSearchTypeNeedingOr(queryCategory);
            }

            let vCnt: number = 0;

            if (categoryCnt != 0 && (!this.isIgnoredCategories(queryCategory.type))) {
                qStr = qStr + " AND ";
            }
            
            if (!this.isIgnoredCategories(queryCategory.type)) {
                if(queryCategory.queryValues.length === 1) {
                    let escapedValue: string = this.escapeChars(queryCategory.queryValues[0].value);
                    if(escapedValue.substring(0,1) === '-') {
                        qStr = qStr + "-((" + queryCategory.type + ":" + this.addQuotes(queryCategory.type, escapedValue.substring(1)) + 
                                            this.adjustQueryByType(queryCategory.type) + ")";
                    }
                    else{
                        qStr = qStr + "((" + queryCategory.type + ":" +  this.addQuotes(queryCategory.type, escapedValue) + 
                                            this.adjustQueryByType(queryCategory.type) + ")";
                    }
                }
                else {
                    for (let queryValue of queryCategory.queryValues) {
                        let escapedValue: string = this.escapeChars(queryValue.value);
                        if (vCnt > 0) {
                            if (isNeedingOr) {
                                qStr = qStr + "  OR"  + " (" + queryCategory.type + ":" + this.addQuotes(queryCategory.type, escapedValue) + 
                                this.adjustQueryByType(queryCategory.type) + ")";
                            }
                            else {
                                if(escapedValue.substring(0,1) === '-'){
                                        qStr = qStr + ") AND -((" + queryCategory.type + ":" + this.addQuotes(queryCategory.type, escapedValue.substring(1)) +
                                            this.adjustQueryByType(queryCategory.type) + ")";
                                }
                                else {
                                        qStr = qStr + ") AND ((" + queryCategory.type + ":" + this.addQuotes(queryCategory.type, escapedValue) +
                                            this.adjustQueryByType(queryCategory.type) + ")";
                                }
                            }
                        }
                        else {
                            if(escapedValue.substring(0,1) === '-') {
                                qStr = qStr + "-((" + queryCategory.type + ":" + this.addQuotes(queryCategory.type, escapedValue.substring(1)) + 
                                                    this.adjustQueryByType(queryCategory.type) + ")";
                            }
                            else {
                                qStr = qStr + "((" + queryCategory.type + ":" + this.addQuotes(queryCategory.type, escapedValue) +
                                                    this.adjustQueryByType(queryCategory.type) + ")";
                            }
                        }
                        
                        vCnt++
                    }
                }
                categoryCnt++;
            }
            
            if (!this.isIgnoredCategories(queryCategory.type)) {
                qStr = qStr + ")"; 
            }
        }
        
        qStr = this.appendEinPn(queryCategories, qStr, isCategoryEinPnCombo);
        qStr = qStr + ")";
        console.log("FINAL qStr = " + qStr);
        return qStr;
    }

    private adjustQueryByType(categoryType: string) : string {
        let retStr: string = "";

        if (categoryType == this.staticsService.getCategoryType().ACK_ID) {
            retStr = " AND -(dcgind:" + this.addQuotes(categoryType, QueryStringBuilderService.QUERY_DCGIND_TRUE) + ")";
        }

        return retStr;
    }

    private appendEinPn(queryCategories: QueryCategory[], inQueryStr: string, isCategoryEinPnCombo: boolean) : string {

        let retStr:  string = inQueryStr;
        let foundEins: string[] = [];
        let foundPns: string[] = [];

        queryCategories.forEach(queryCategory => {
            if (queryCategory.type == this.staticsService.getCategoryType().EIN)  {
                queryCategory.queryValues.forEach(queryValue => {
                    foundEins.push(queryValue.value);
                });
            }
        });

        queryCategories.forEach(queryCategory => {
            if (queryCategory.type == this.staticsService.getCategoryType().PN)  {
                queryCategory.queryValues.forEach(queryValue => {
                    foundPns.push(queryValue.value);
                });
            }
        });
        
        if (foundEins.length != 0 && foundPns.length != 0) {
        
            let isFirst: boolean = true;
            let einCnt: number = 0;

            foundEins.forEach(ein => {
                let pnCnt: number = 0;
                einCnt++;

                foundPns.forEach(pn => {
                    let escapePnValue: string = this.escapeChars(pn);
                    let escapeEinValue: string = this.escapeChars(ein);
                    pnCnt++
                    
                    if (isFirst) {
                        if (queryCategories.length > 2){
                            retStr = retStr + " AND (";
                        }
                        isFirst = false;
                        retStr = this.addStrBoth(retStr, escapeEinValue, escapePnValue);
                        if (foundEins.length == 1 && foundPns.length == 1) {
                            retStr = retStr + ")";
                        }
                    }
                    else {
                        retStr = retStr + ") OR ";
                        retStr = this.addStrBoth(retStr, escapeEinValue, escapePnValue);
                        if ((einCnt == foundEins.length && pnCnt == foundPns.length) && (queryCategories.length > 2)) {
                            retStr = retStr + ")";
                        }
                    }
                });
            });
            if (queryCategories.length > 2 || foundEins.length > 1 || foundPns.length > 1) {
                retStr = retStr + ")";
            }
 
        }
        else if (foundPns.length > 0) {
            let isFirst: boolean = true;
                foundPns.forEach(pn => {
                let escapedValue: string = this.escapeChars(pn);

                if (isFirst) {
                    isFirst = false;
                    if (queryCategories.length > 1){
                        retStr = retStr + " AND ";
                    }
                    retStr = this.addOrStrFirst(this.staticsService.getCategoryType().PN, retStr, escapedValue);
                }
                else {
                    retStr = this.addOrStrAfter(this.staticsService.getCategoryType().PN, retStr, escapedValue);
                }
                
            });
            retStr = retStr + ")"; 
        }
        else if (foundEins.length > 0) {
            let isFirst: boolean = true;
            foundEins.forEach(ein => {
                let escapedValue: string = this.escapeChars(ein);
                
                if (isFirst) {
                    isFirst = false;

                    if (queryCategories.length > 1){
                        retStr = retStr + " AND ";
                    }
                    retStr = this.addOrStrFirst(this.staticsService.getCategoryType().EIN, retStr, escapedValue);
                }
                else {
                    retStr = this.addOrStrAfter(this.staticsService.getCategoryType().EIN, retStr, escapedValue);
                }
                
            });
            retStr = retStr + ")"; 
        }

        return retStr;
    }

    private addStrBoth(inQueryStr: string, escapeEinValue: string, escapePnValue: string) : string {
        let retStr:  string = inQueryStr;

        if (escapeEinValue.substring(0,1) === '-' || escapePnValue.substring(0,1) === '-') {
            if (escapeEinValue.substring(0,1) === '-') {
                escapeEinValue = escapeEinValue.substring(1);
            }
            retStr = retStr + "((" + this.staticsService.getCategoryType().EIN + ":" + this.addQuotes(this.staticsService.getCategoryType().EIN, escapeEinValue) + ")";
            
            if (escapePnValue.substring(0,1) === '-') {
                escapePnValue =  escapePnValue.substring(1);
            }
            retStr = retStr + " AND"  + " (" + this.staticsService.getCategoryType().PN + ":" + this.addQuotes(this.staticsService.getCategoryType().PN, escapePnValue) + ")";
        }
        else {
            retStr = retStr + "((" + this.staticsService.getCategoryType().EIN + ":" + this.addQuotes(this.staticsService.getCategoryType().EIN, escapeEinValue);
            retStr = retStr + " AND "  +  this.staticsService.getCategoryType().PN + ":" + this.addQuotes(this.staticsService.getCategoryType().PN, escapePnValue) + ")";
        }

        return retStr;
    }


    private addOrStrFirst(categoryType: string, inQueryStr: string, escapeValue: string) : string {
        let retStr:  string = inQueryStr;

        if(escapeValue.substring(0,1) === '-') {
            retStr = retStr + "((" + categoryType + ":" + this.addQuotes(categoryType, escapeValue.substring(1)) + ")";
        }
        else {
            retStr = retStr + "((" + categoryType  + ":" + this.addQuotes(categoryType, escapeValue) + ")";
        }

        return retStr;
    }

    private addOrStrAfter(categoryType: string, inQueryStr: string, escapeValue: string) : string {
        let retStr:  string = inQueryStr;

        if(escapeValue.substring(0,1) === '-') {
            retStr = retStr  + " OR " +  "(" + categoryType + ":" + this.addQuotes(categoryType, escapeValue.substring(1)) + ")";
        }
        else {
            retStr = retStr +  " OR " + "(" + categoryType + ":" + this.addQuotes(categoryType, escapeValue) + ")";
        }

        return retStr;
    }

    private addQuotes(categoryType: string, inStr: string) : string {

        let  retStr:  string = "";

        if (categoryType.trim() == "participantsboy" || categoryType.trim() =="assetseoy"  || 
            categoryType.trim() =="zip"|| categoryType.trim() == "businesscode" || categoryType.trim() == "plantype") {
            retStr = inStr;
        }
        else if (inStr.indexOf("*") != -1) {
            retStr = inStr;
        }
        else {
            if (this.doesStrContainBeginEndQuotes(inStr)) {
                retStr = inStr;
            }
            else {
                retStr =  "\"" + inStr + "\"";
            }
            
        }

        return retStr;
    }

    private doesStrContainBeginEndQuotes(str:string) : boolean {

        if (str.length >= 2) {
            return str.charAt(0) === "\"" && str.charAt(str.length - 1) === "\"";
        }
        else {
            return false;
        }
    }

    private escapeChars(str: string) : string {
        let escapedStr: string = "";

        escapedStr = str.trim().replace('(', '\\(');
        escapedStr = escapedStr.replace(')', '\\)');
        escapedStr = escapedStr.replace('%', '%25%20');
        escapedStr = escapedStr.replace('?', '%5C%20');
        escapedStr = escapedStr.replace(';', '');
        return escapedStr;
    }

    private getPotentialMinus(type : string, val: string): string {
        let retVal: string = val;

        let NOT = "NOT";
        let SPACER = " ";
        let HYPHEN = "-"; 

        if (val.length > 0) {
            if (val.substring(0,1) == "-") {
              retVal = SPACER + "AND"+ SPACER + HYPHEN + "("+ type + ":" +  val.substring(1)  +")";
            }
            else{
                //no negative return without modification
                retVal = SPACER + "AND"+ SPACER +"("+ type + ":" + val +")";
            }
        }

        return retVal;
    }

    private isSearchTypeNeedingOr(queryCategory: QueryCategory): boolean {
        let isTypeOr: boolean = false;
        if (queryCategory.type == this.staticsService.getCategoryType().EIN ||
            queryCategory.type == this.staticsService.getCategoryType().PN ||
            queryCategory.type == this.staticsService.getCategoryType().ACK_ID ||
            queryCategory.type == this.staticsService.getCategoryType().PLAN_CODE)
        {
            isTypeOr = true;
        }
        return isTypeOr;
    }
}
